import CategoryFeature from './CategoryFeature';
import { useShop } from '../../../Providers/ShopProvider';

import './Styles/CategoryFeatureStyles.css'

const CategoriesFeature = () => {

    const { activeCategory, setActiveCategory, rootCategories, categoryData, setShowFeatureListFilter, isLoadingRootCategories } = useShop()

    const handleCategoryFeatureClick = (category) => {
        setActiveCategory(category)
        setShowFeatureListFilter(true)
    }

    const generateRootCategories = () => {
        var categories = rootCategories.filter(c => c.artCount > 0)
        if (!categories || categories.length === 0) {
            return <b className='ms-2'>Brak kategorii odpowiadającym założonym filtrom.</b>
        }
        else {
            return (<div className='col'>
                {
                    categories.map(category => {
                        return (<>
                            <CategoryFeature
                                category={category}
                                onClick={() => handleCategoryFeatureClick(category)}
                            />

                            <div className="row">
                                <div className="col px-5">
                                    {category.subCategories.filter(c => c.artCount > 0).map(c => {
                                        return <CategoryFeature
                                            category={c}
                                            onClick={() => handleCategoryFeatureClick(c)}
                                            active={false}
                                        />
                                    })}
                                </div>
                            </div>
                        </>)
                    })
                }
            </div>)
        }
    }

    if (isLoadingRootCategories) {
        return (
            <>
                <p class="card-text placeholder-glow">
                    <span class="placeholder col-7"></span>
                    <span class="placeholder col-4"></span>
                    <span class="placeholder col-4"></span>
                    <span class="placeholder col-6"></span>
                    <span class="placeholder col-8"></span>

                    <span class="placeholder col-7"></span>
                    <span class="placeholder col-4"></span>
                    <span class="placeholder col-4"></span>
                    <span class="placeholder col-6"></span>
                    <span class="placeholder col-8"></span>
                </p>
            </>
        )
    }
    if (!activeCategory)
        return < div className='row' >
            {generateRootCategories()}
        </div>
    if (categoryData && categoryData.length > 1) {
        return (
            <div className='row'>
                {categoryData.map((c, index) => (
                    <CategoryFeature
                        key={index}
                        category={c.parentCategory}
                        hasNoParent={false}
                        active={false}
                        showCount={true}
                        onClick={() => handleCategoryFeatureClick(c.currentCategory)}
                    />
                ))}
            </div>
        )
    }
    return (categoryData &&
        <div className='row' >
            <div className='col'>
                <div className='row mx-1 mb-3' style={{ fontSize: 34, fontWeight: 'bold' }}>
                    {categoryData.currentCategory.catDescription}
                </div>
                <CategoryFeature
                    category={categoryData.parentCategory}
                    hasNoParent={(categoryData.currentCategory.parentNodeId === 0)}
                    onClick={() => {
                        if (categoryData.currentCategory.parentNodeId === 0) {
                            handleCategoryFeatureClick(null)
                            localStorage.setItem("categoryNavigationTree", JSON.stringify(null))
                        }
                        else {
                            handleCategoryFeatureClick(categoryData.parentCategory)
                        }
                    }}
                    active={true}
                    showCount={false}
                />
                <div className='row mt-3'></div>
                <CategoryFeature
                    category={categoryData.currentCategory}
                    onClick={() => handleCategoryFeatureClick(categoryData.currentCategory)}
                    active={true}
                />
                <div className='row'>
                    <div className='col px-5'>
                        {categoryData.currentCategory.subCategories.filter(c => c.artCount > 0).map((subCat) => {
                            return <CategoryFeature
                                category={subCat}
                                onClick={() => handleCategoryFeatureClick(subCat)}
                            />
                        })}
                    </div>
                    {categoryData.sameParentCategories.filter(c => c.artCount > 0).map((subCat) => {
                        return <CategoryFeature
                            category={subCat}
                            onClick={() => handleCategoryFeatureClick(subCat)}
                        />
                    })}
                </div>
            </div>
        </div >
    )
}

export default CategoriesFeature